import { Listener, Listeners } from 'util/listener'

export class WidgetListeners {
  private _listeners = new Map<string, Listeners<unknown>>()
  private _events = new Map<string, unknown>()

  on(name: string, listener: Listener) {
    this.listeners(name).add(listener)
    const event = this._events.get(name)
    if (event) listener(event)
  }

  fire(name: string, event: unknown) {
    this._events.set(name, event)
    return this.listeners(name).fire(event)
  }

  clear() {
    this._listeners.clear()
    this._events.clear()
  }

  private listeners(name: string): Listeners<unknown> {
    let listeners = this._listeners.get(name)
    if (!listeners) this._listeners.set(name, listeners = new Listeners())
    return listeners
  }
}
